import { useQuery } from "@tanstack/react-query";
import {
  getCachedLoginMarketingConfig,
  loginMarketingConfigApi,
} from "../services/api/loginMarketingConfig";

// Unlike every other hook here, this runs before login — no schoolId/token
// to gate on, so it's always enabled.
export const useLoginMarketingConfig = () => {
  return useQuery({
    queryKey: ["login-marketing-config"],
    queryFn: loginMarketingConfigApi.getConfig,
    // A repeat visitor's last-fetched config renders immediately instead of
    // the hardcoded defaults, avoiding the flash while the real request is
    // in flight. initialDataUpdatedAt: 0 marks it as already stale so the
    // query still fetches in the background and updates if it's changed.
    initialData: getCachedLoginMarketingConfig,
    initialDataUpdatedAt: 0,
    staleTime: 5 * 60 * 1000, // Data is considered fresh for 5 minutes
    gcTime: 30 * 60 * 1000, // Cache is kept for 30 minutes
    retry: 1,
  });
};
